import { render, staticRenderFns } from "./date-and-time-formats.vue?vue&type=template&id=713b6f38"
var script = {}
import style0 from "./date-and-time-formats.vue?vue&type=style&index=0&id=713b6f38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports